const styles = (theme) => ({
    container: {
      borderRadius: '2px',
      boxShadow: `0px 0px 4px ${theme.HeaderDefaultTextColor}`,
      padding: 14,
      marginBottom: 20,
    },
    locationName: {
      width: "75%",
      marginBottom: 0,
    },
    highlightedCard: {
      border: `2px solid ${theme.HeaderSelectedText}`,
      boxShadow: "0 14px 28px rgba(0,0,0,0.25)",
    },
  });
  
  export default styles;
  